import { ReactQRCode } from '@lglab/react-qr-code'
import liff from '@line/liff'
import { useCallback, useEffect, useState } from 'react'

import { Skeleton } from '../ui/skeleton'

type LIFFQRProps = {
  path: string
  size?: number
  color?: string
}

export const LIFFQR = ({ path, size = 128, color }: LIFFQRProps) => {
  const [isLoading, setIsLoading] = useState(true)
  const [liffUrl, setLiffUrl] = useState<string | null>(null)

  const loadLIFFQR = useCallback(async () => {
    const origin = path?.startsWith('http') ? path : window.location.origin
    const newURL = new URL(path, origin)
    const liffUrl = await liff.permanentLink.createUrlBy(newURL.href)
    setLiffUrl(liffUrl)
    setIsLoading(false)
  }, [path])

  useEffect(() => {
    loadLIFFQR()
  }, [loadLIFFQR])

  if (isLoading || !liffUrl) {
    return (
      <Skeleton
        style={{
          width: `${size}px`,
          height: `${size}px`,
        }}
      />
    )
  }

  return (
    <div>
      <ReactQRCode
        value={liffUrl}
        size={size}
        dataModulesSettings={{ color }}
        finderPatternInnerSettings={{ color }}
        finderPatternOuterSettings={{ color }}
      />
    </div>
  )
}
